const CORRECT_LOGIN_PASS = "CORRECT_LOGIN_PASS";
const FIRST_LOGIN = "FIRST_LOGIN";
const CAPTCHA_ERROR = "CAPTCHA_ERROR";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_ERROR = "LOGIN_ERROR";
const FIRST_ACCESS = "FIRST_ACCESS";
const SAVE_TOKEN = "SAVE_TOKEN";
const TOKEN_ERROR = "TOKEN_ERROR";
const SET_USER_DATA = "SET_USER_DATA";
const SET_CAPTCHA_DATA = "SET_CAPTCHA_DATA";
const HOMESCREEN = "HOMESCREEN";
const SEND_MAIL = "SEND_MAIL";


const initialState = {
  isCorrectLoginPass: false,
  isFirstLogin: true,
  isCaptchaError: false,
  isLoginSuccess: false,
  isLoginError: null,
  isFirstAccess: null,
  tokenError: null,
  token: null,
  user: {},
  catpcha: {},
  homescreen: null,
  sendEmail: false
};

export default function login(state = initialState, action) {
  switch (action.type) {
    case CORRECT_LOGIN_PASS:
      return {
        ...state,
        isCorrectLoginPass:  action.isCorrectLoginPass
      }
    case FIRST_LOGIN:
      return {
        ...state,
        isFirstLogin: action.isFirstLogin
      }
    case CAPTCHA_ERROR:
      return {
        ...state,
        isCaptchaError: action.isCaptchaError
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoginSuccess: action.isLoginSuccess
      };

    case LOGIN_ERROR:
      return {
        ...state,
        isLoginError: action.isLoginError
      };

      case FIRST_ACCESS:
      return {
        ...state,
        isFirstAccess: action.isFirstAccess
      };

    case SAVE_TOKEN:
      return {
        ...state,
        token: action.token
      };

    case TOKEN_ERROR:
      return {
        ...state,
        tokenError: action.tokenError
      };

    case SET_USER_DATA:
      return {
        ...state,
        user: action.user
      };

    case SET_CAPTCHA_DATA:
       return{
         ...state,
         catpcha: action.captcha
       };

    case HOMESCREEN:
      return {
        ...state,
        homescreen: action.homescreen
      };

      case SEND_MAIL:
      return{
        ...state,
        sendMail: action.sendMail,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/login.js